/* eslint-disable */

import { HiXCircle } from "react-icons/hi";
import Links from "./components/Links";
import SidebarCard from "components/sidebar/componentsrtl/SidebarCard";
import routes from "routes";


const Sidebar = (props: {
  open: boolean;
  onClose: React.MouseEventHandler<HTMLSpanElement>;
}) => {
  const { open, onClose } = props;
  return (
    <div
      className={`sm:none duration-175 linear fixed !z-50 flex min-h-full flex-col bg-white pb-10 shadow-2xl shadow-white/5 transition-all dark:!bg-navy-800 dark:text-white md:!z-50 lg:!z-50 xl:!z-0 ${
        open ? "translate-x-0" : "-translate-x-96"
      }`}
    >

      <div className={`mx-[56px] mt-[50px] flex items-center`}>
        <div className="mt-1 ml-1 h-1.5 font-poppins text-[14px] font-bold uppercase text-navy-700 dark:text-white">
         <span className="bg-navy-400 text-white px-2 py-1 rounded">Apex</span> <span className="font-medium">Learning Solution</span>
        </div>
      </div>
      <div className="mt-[58px] mb-7 h-px bg-gray-300 dark:bg-white/30" />
      {/* Nav item */}

     <div className="flex ml-60  justify-between w-full item cursor-pointer xl:hidden z-0 md:z-50 text-red-700">
       <span onClick={onClose}>
         <HiXCircle className="w-6 h-6"/>
       </span>
     </div>
      <ul
        className="mb-auto pt-1"
        onClick={window.innerWidth < 1200 ? onClose : undefined}
      >
        <Links routes={routes} />
      </ul>

      {/* Free Horizon Card */}
      <div className="flex justify-center">
        <SidebarCard />
      </div>

      {/* Nav item end */}
    </div>
  );
};

export default Sidebar;
